<template lang="pug">
.users
  v-overlay(v-if="update", :value="overlay")
    v-progress-circular(indeterminate, size="64")
  v-card.elevation-12
    v-toolbar(color="primary", dark="", flat="")
      v-toolbar-title Registro de Usuario
    .alert(v-if="messages_error_request")
      v-alert(border="top", color="red lighten-2", dark)
        ul
          li(v-for="message in messages_error_request") {{ message }}
    v-card-text
      ValidationObserver(
        ref="observer_user_data",
        v-slot="{ validate, reset }"
      )
        v-form
          v-row
            v-col(cols="12", :md="user.role.slug == 'owner' ? '12' : '6'")
              ValidationProvider(
                v-slot="{ errors }",
                name="Correo Electrónico",
                rules="required|email"
              )
                v-text-field(
                  v-model="user_data.email",
                  label="Correo Electrónico",
                  type="text",
                  prepend-icon="fa-envelope",
                  :error-messages="errors",
                  required
                )
            v-col(v-if="user.role.slug != 'owner'", cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                name="Rol",
                rules="required"
              )
                v-autocomplete(
                  v-model="user_data.role",
                  label="Rol",
                  prepend-icon="fa-user-tag",
                  :items="getRoles",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  single-line,
                  hide-details,
                  required
                )
            v-col(cols="12", md="12")
              h3 Datos Personales
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                name="Nombre(s)",
                rules="required"
              )
                v-text-field(
                  v-model="user_data.first_name",
                  label="Nombre(s)",
                  prepend-icon="fa-user",
                  type="text",
                  :error-messages="errors",
                  required
                )
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                name="Apellido(s)",
                rules="required"
              )
                v-text-field(
                  v-model="user_data.last_name",
                  label="Apellido(s)",
                  type="text",
                  prepend-icon="fa-user",
                  :error-messages="errors",
                  required
                )
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                name="Telefono",
                rules="required|numeric"
              )
                v-text-field(
                  v-model="user_data.phone_number",
                  label="Telefono",
                  prepend-icon="fa-phone",
                  type="number",
                  :error-messages="errors",
                  required
                )
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                name="Celular",
                rules="required|numeric"
              )
                v-text-field(
                  v-model="user_data.phone_number_mobile",
                  label="Celular",
                  prepend-icon="fa-mobile-alt",
                  type="number",
                  :error-messages="errors",
                  required
                )
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                name="País",
                rules="required"
              )
                v-autocomplete(
                  v-model="user_data.country",
                  label="País",
                  :items="countries",
                  item-text="name",
                  item-value="id",
                  prepend-icon="fa-globe",
                  :error-messages="errors",
                  single-line,
                  hide-details,
                  required
                )
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                name="Departamento(Estado)",
                rules="required"
              )
                v-autocomplete(
                  v-model="user_data.state",
                  label="Departamento(Estado)",
                  prepend-icon="fa-flag",
                  :items="states",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  single-line,
                  hide-details,
                  required
                )
            v-col(cols="12", md="4")
              ValidationProvider(
                v-slot="{ errors }",
                name="Ciudad",
                rules="required"
              )
                v-autocomplete(
                  v-model="user_data.city",
                  label="Ciudad",
                  prepend-icon="fa-city",
                  :items="cities",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  single-line,
                  hide-details,
                  required
                )
            v-col(cols="12", md="4")
              ValidationProvider(
                v-slot="{ errors }",
                name="Barrio",
                rules="required"
              )
                v-text-field(
                  v-model="user_data.neighborhood",
                  label="Barrio",
                  prepend-icon="fa-building",
                  type="text",
                  :error-messages="errors",
                  required
                )
            v-col(cols="12", md="4")
              ValidationProvider(
                v-slot="{ errors }",
                name="Dirección",
                rules="required"
              )
                v-text-field(
                  v-model="user_data.address",
                  label="Dirección",
                  prepend-icon="fa-map-marker-alt",
                  type="text",
                  :error-messages="errors",
                  required
                )
      v-card-actions
        v-spacer
        v-btn(
          color="secondary",
          @click="createUpdateUser",
          :loading="loading",
          :disabled="loading"
        ) Guardar
</template>

<script>
import { mapState } from "vuex";
import userAPI from "@/api/user";
import { required, email, min, numeric } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} no puede ser vacío"
});

extend("min", {
  ...min,
  message: "{_field_} no puede ser menor que {length} caracteres"
});

extend("numeric", {
  ...numeric,
  message: "{_field_} no admite números"
});

extend("email", {
  ...email,
  message: "Correo Electrónico debe ser válido"
});

export default {
  name: "User",
  async created() {
    if (this.update) {
      const response = await userAPI.getUser(this.auth_token, this.username);
      this.overlay = false;
      if (response.status) {
        this.user_data.email = response.data.email;
        this.user_data.role = response.data.role.id;
        this.user_data.city = response.data.city.id;
        this.user_data.state = response.data.state.id;
        this.user_data.address = response.data.address;
        this.user_data.country = response.data.country.id;
        this.user_data.last_name = response.data.last_name;
        this.user_data.first_name = response.data.first_name;
        this.user_data.neighborhood = response.data.neighborhood;
        this.user_data.phone_number = response.data.phone_number;
        this.user_data.phone_number_mobile = response.data.phone_number_mobile;
        this.user_data.vet_username = response.data.vet_username;
      } else {
        this.$swal({
          icon: "warning",
          title: response.data
        });
      }
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    update: {
      type: Boolean,
      required: false,
      default: false
    },
    username: {
      type: Number | String,
      required: false,
      default: 0
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      roles: state => state.roles.roles,
      cities: state => state.locations.cities,
      states: state => state.locations.states,
      auth_token: state => state.auth.auth_token,
      countries: state => state.locations.countries
    }),
    getRoles() {
      let newRoles = [];
      for (let i in this.roles) {
        if (this.user.role.slug == "vet") {
          if (this.roles[i].slug == "owner") newRoles.push(this.roles[i]);
        } else {
          newRoles.push(this.roles[i]);
        }
      }

      return newRoles;
    }
  },
  data() {
    return {
      show_password: false,
      show_password_conf: false,
      messages_error_request: null,
      loading: false,
      overlay: true,
      user_data: {
        email: null,
        address: null,
        neighborhood: null,
        phone_number_mobile: null,
        phone_number: null,
        first_name: null,
        last_name: null,
        role: null,
        country: null,
        state: null,
        city: null,
        vet_username: null
      }
    };
  },
  methods: {
    async createUpdateUser() {
      this.messages_error_request = null;
      if (await this.$refs.observer_user_data.validate()) {
        this.loading = true;
        if (this.update) {
          const response = await userAPI.updateUser(
            this.auth_token,
            this.username,
            this.user_data
          );
          // response.status ? await this.getUsers(this.update) : this.messages_error_request = response.data;
          response.status
            ? await this.getUsers(this.update)
            : this.$swal({
                icon: "success",
                title: response.data
              });
        } else {
          const response = await userAPI.createUser(
            this.auth_token,
            this.user_data
          );
          response.status
            ? await this.getUsers(this.update)
            : this.$swal({
                icon: "warning",
                title: response.data
              });
        }
        this.loading = false;
      }
    },
    async getUsers(action) {
      let title = "";
      action ? (title = "Actualizado") : (title = "Creado");
      this.$swal({
        title: `Usuario ${title}`,
        icon: "success"
      });
      await this.$store.dispatch("users/getUsers", {
        token: this.auth_token,
        page: 1
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.alert {
  padding: 15px;
}
</style>
